import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const RFPGuide = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL('https://rfpguide.com/' + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = 'https://rfpguide.com/';
    }
  }, [pathURL]);
  return <div />;
};

export default RFPGuide;
